import React from "react";
import { Outlet, NavLink, useNavigate, Link } from "react-router-dom";
import { LayoutList, PlusCircle, LogOut } from "lucide-react";
import Logo from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";

const nav = [
  { to: "/portal", label: "My Requests", icon: LayoutList, end: true },
  { to: "/portal/new", label: "New Request", icon: PlusCircle },
];

export default function ClientLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const doLogout = () => { logout(); navigate("/"); };

  return (
    <div className="min-h-screen flex bg-background">
      <aside className="w-64 shrink-0 bg-white border-r border-zinc-200 flex flex-col fixed h-screen">
        <div className="p-6 border-b border-zinc-200">
          <Logo />
        </div>
        <nav className="flex-1 p-4 space-y-1">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-2.5 rounded-sm text-sm font-semibold transition-colors ${
                  isActive ? "bg-ink text-white" : "text-zinc-600 hover:bg-zinc-100"
                }`
              }
              data-testid={`client-nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
            >
              <n.icon size={18} /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-zinc-200">
          <div className="px-2 mb-3">
            <div className="text-sm font-semibold truncate">{user?.name}</div>
            <div className="text-xs text-zinc-500 truncate">{user?.email}</div>
          </div>
          <button onClick={doLogout} className="flex items-center gap-3 px-4 py-2.5 rounded-sm text-sm font-semibold text-zinc-600 hover:bg-zinc-100 w-full transition" data-testid="client-logout">
            <LogOut size={18} /> Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 ml-64 p-6 md:p-10">
        <Outlet />
      </main>
    </div>
  );
}
